import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MaintenanceDashboard from "./MaintenanceDashboard";

const MaintenanceDB = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.key === undefined || location.key === null || location.key === 'default') {
      navigate("/");
    }
  }, [location, navigate]);

  return <MaintenanceDashboard />;
};

export default MaintenanceDB;
